import * as Types from '../constants/Types';
import { PAGINATION } from '../constants/Define';
import VinwonderTagGroup from '../models/VinWonderTagGroup';

const initialState = {
    isFetching: false,
    isFetchingDetail: false,
    isFetchingTranslate: false,
    pageSize: PAGINATION.pageSize,
    pageIndex: PAGINATION.pageIndex,
    totalCount: PAGINATION.totalCount,
    supplierCategories: [],
    listVWTagGroupAll: [],
    listVWTagGroupFollowSupplier: [],
    skusFollowSupplier: [],
    vinwonderTagGroupDetail: new VinwonderTagGroup(),
    isLoadingSku: false,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.VINWONDER_TAGGROUP_LIST_ACTION:
            return { ...state, isFetching: true };
        case Types.VINWONDER_TAGGROUP_LIST_SUCCESS:
            return {
                ...state, isFetching: false,
                listVWTagGroupAll: action.listVinwonderTagGroups,
                pageSize: action.pageSize,
                pageIndex: action.pageIndex,
                totalCount: action.totalCount,
                totalPage: Math.ceil(parseInt(action.totalCount) / parseInt(action.pageSize)),
            };
        case Types.VINWONDER_TAGGROUP_LIST_SUPPLIERS_ACTION:
            return { ...state, isFetching: true };
        case Types.VINWONDER_TAGGROUP_LIST_SUPPLIERS_SUCCESS:
            return { 
                ...state, isFetching: false,
                supplierCategories: action.supplierCategories
             };
        case Types.VINWONDER_TAGGROUP_LIST_SKU_ACTION:
                return { ...state, isLoadingSku: true };
        case Types.VINWONDER_TAGGROUP_LIST_SKU_SUCCESS:
            return { 
                ...state, isLoadingSku: false,
                skusFollowSupplier: action.listSkus
            };
        case Types.VINWONDER_TAGGROUP_DETAIL_ACTION:
            return { ...state, isFetchingDetail: true, vinwonderTagGroupDetail: new VinwonderTagGroup() };
        case Types.VINWONDER_TAGGROUP_DETAIL_SUCCESS:
            return { ...state, isFetchingDetail: false, vinwonderTagGroupDetail: action.vinwonderTagGroup };
        case Types.VINWONDER_TAGGROUP_DRAG_ACTION: 
            return { ...state, isFetching: true};
        case Types.VINWONDER_TAGGROUP_DRAG_SUCCESS: 
            return { ...state, isFetching: false};
        case Types.VINWONDER_TAGGROUP_UPDATE_DEFAULT_TAG_IN_SUPPLIER_ACTION: 
            return { ...state, isFetching: true};
        case Types.VINWONDER_TAGGROUP_UPDATE_DEFAULT_TAG_IN_SUPPLIER_SUCCESS: 
            return { ...state, isFetching: false};
        case Types.VINWONDER_TAGGROUP_CREATE_TRANSLATE_ACTION:
            return { ...state, isFetchingTranslate: true };
        case Types.VINWONDER_TAGGROUP_CREATE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingTranslate: false };
        case Types.VINWONDER_TAGGROUP_UPDATE_TRANSLATE_ACTION:
            return { ...state, isFetchingTranslate: true };
        case Types.VINWONDER_TAGGROUP_UPDATE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingTranslate: false };
        case Types.VINWONDER_TAGGROUP_DELETE_TRANSLATE_ACTION:
            return { ...state, isFetchingTranslate: true };
        case Types.VINWONDER_TAGGROUP_DELETE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingTranslate: false };
        default:
            return state;
    }
}
